import axios from "axios";

export default function requestValuesByConfigString(
  baseRestUrl,
  context,
  configString,
  onSuccess,
  onError
) {
  const url = `${baseRestUrl}/configreverselookup/${context}`;
  const body = {
    configString,
  };
  const headers = {
    "Content-Type": "application/json",
  };

  axios
    .post(url, body, { headers })
    .then(response => {
      const { status, data } = response;
      if (status === 200 && data.chosenValues) {
        onSuccess(data.chosenValues);
      } else {
        onError({
          errorMessage: "Response status is not 200 or choseValues is missing",
          response,
        });
      }
    })
    .catch(error => {
      onError(JSON.stringify(error));
    });
}
